import React from 'react';
import PropTypes from 'prop-types';

const PillarsSection = ({ items }) => {
  const pillars = Array.isArray(items) ? items : [];

  return (
    <section
      id="features"
      className="px-6 py-20 md:py-28 bg-gradient-to-b from-[#0f1115] via-[#131820] to-[#0f1115]"
    >
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#f8f5ed] mb-4">
            Everything your chama needs.
            <br />
            <span className="text-emerald-400">Nothing it doesn&apos;t.</span>
          </h2>
          <p className="text-lg text-[#d8d2c5] max-w-2xl mx-auto">
            No complicated menus. No features you&apos;ll never use. Just the tools that matter.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {pillars.map((pillar, idx) => (
            <div
              // eslint-disable-next-line react/no-array-index-key
              key={`pillar-${idx}`}
              className="rounded-2xl border border-white/10 bg-white/5 p-6 backdrop-blur"
            >
              <div className="text-xs font-medium text-emerald-200/80 uppercase tracking-widest mb-3">
                {pillar.label}
              </div>
              <div className="text-xl font-semibold text-[#f8f5ed] mb-2">{pillar.title}</div>
              <div className="text-sm text-[#d8d2c5]/85 leading-relaxed">{pillar.body}</div>
              {pillar.stats ? (
                <div className="mt-4 text-sm font-semibold text-emerald-300">{pillar.stats}</div>
              ) : null}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

PillarsSection.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      title: PropTypes.string,
      body: PropTypes.string,
      stats: PropTypes.string,
    })
  ),
};

PillarsSection.defaultProps = {
  items: [],
};

export default PillarsSection;
